module.exports = __webpack_public_path__ + "img/Bode_Loader.0bac0d9.gif";